import { Cookies } from 'react-cookie';

import { VisitReport } from './type';

import axiosInterceptor from 'api/interceptor/axiosClient';

interface GetVisitReports {
  slug: string;
  id: string;
}

export const getVisitReports = async ({ slug, id }: GetVisitReports) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/visit_report/${slug}/${id}/`, {
    headers: {
      Authorization: token,
    },
  });

  return data.data as VisitReport;
};
